import React, {memo} from 'react'
import packageJson from '../../../package.json'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

function AppVersion(props) {
    const {
        builtBy,
    } = props

    const appVersion = `v${packageJson.version}`

    return (
        <Typography variant='caption'>{appVersion}{builtBy &&
            <span> - built with ❤️ <a className='link-decoration__plain'
                                      target='_blank'
                                      rel='noreferrer'
                                      href='https://pnn-it.de'>pnn-it.de</a></span>}</Typography>
    )
}

export default memo(AppVersion)

AppVersion.propTypes = {
    builtBy: PropTypes.bool.isRequired,
}

